import React, { StrictMode } from 'react';
import { ContextProvider as UsersContextProvider } from 'components/Users/Context';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from 'app/routes';
import Main from './Main';

import UpdateEmail from '../Settings/UpdateEmail';

export default function Index() {
  const router = createBrowserRouter([
    {
      path: routes.members.activateProgram.index,
      element: <Main />,
      children: [
        {
          path: routes.members.activateProgram.emailUpdate,
          element: <UpdateEmail />,
        },
      ],
    },
  ]);

  return (
    <StrictMode>
      <UsersContextProvider>
        <RouterProvider router={router} />
      </UsersContextProvider>
    </StrictMode>
  );
}
